import { render, staticRenderFns } from "./openCode.vue?vue&type=template&id=40596b66&scoped=true"
import script from "./openCode.vue?vue&type=script&lang=js"
export * from "./openCode.vue?vue&type=script&lang=js"
import style0 from "./openCode.vue?vue&type=style&index=0&id=40596b66&prod&lang=less&scoped=true"
import style1 from "./openCode.vue?vue&type=style&index=1&id=40596b66&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40596b66",
  null
  
)

export default component.exports